<script>

  import util from './SgsUtils'

  export default{
    props: [
      "attr", "fieldValue", "rules", "placeholder", "label",
      "showHint", "hintValue", "moduleType"
    ],
    data: function() {
      return {
        money: {
          decimal: this.attr.decimalSeparator,
          thousands: this.attr.thousandsSeparator,
          precision: this.attr.decimalDigits
        }
      }
    },
    methods: {
      getPrefix: function(){
        if (this.attr != undefined) {
          if (this.attr.prefix != undefined && this.attr.prefix != ""){
            return " " + this.attr.prefix + " ";
          }
        }
      },
      callBusinessRuleFocus: function() {
        if (this.attr.eventOnFocus) {
          this.$emit('callBusinessRule', this.attr.eventOnFocus);
        }
      },
      callBusinessRuleBlur: function() {
        if (this.attr.eventOnBlur) {
          this.$emit('callBusinessRule', this.attr.eventOnBlur);
        }
      },
      classToDivBeforeInput: function () {
        if(this.attr.disableField) {
          return "el-input is-disabled";
        }
        return "el-input";
      },
      formatValue(value) {

        if (value != undefined) {

          let decimalSeparator = this.attr.decimalSeparator;
          let thousandsSeparator = this.attr.thousandsSeparator;
          let decimalDigits = this.attr.decimalDigits;

          let valueSplit = value.toString().split(".");

          if (decimalDigits > 0) {

            let decimalValue = "";

            if (valueSplit.length > 1) {
              decimalValue = valueSplit[1];
            }

            decimalValue = decimalValue.padEnd(decimalDigits, "0");
            value = valueSplit[0] + "." + decimalValue;

          } else {
            value = valueSplit[0]
          }

          valueSplit = value.toString().split(".");

          let thousandValue = valueSplit[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
          let decimalValue = valueSplit[1].toString();

          return thousandValue + decimalSeparator + decimalValue;
        }
      }
    },
    computed: {
      updateFieldValue: {
        get: function() {

          if (!isNaN(this.fieldValue) && this.fieldValue != undefined) {
            return this.fieldValue;
          }

          return 0;
        },
        set: function(newValue) {
          this.$emit('updateFieldValue', this.attr.columnName, newValue);
        }
      }
    },
    created() {
      util.resolveRules(this.attr, this.rules);
    }
  }
</script>

<template>
  <div>

    <el-popover
      ref="popover"
      v-show="showHint"
      placement="top-start"
      width="200"
      trigger="hover"
      :content="hintValue">
    </el-popover>

    <el-form-item label="temp" :prop="attr.columnName" v-if="moduleType === 'form'">

      <span slot="label">
        {{label}} <i v-if="showHint && moduleType === 'form'" class="glyphicon glyphicon-question-sign" v-popover:popover />
      </span>

      <div class="el-form-item__content">

        <div :class="classToDivBeforeInput()">
          <money
            v-model="updateFieldValue"
            :thousands="attr.thousandsSeparator"
            :decimal="attr.decimalSeparator"
            :precision="attr.decimalDigits"
            @focus="callBusinessRuleFocus"
            @blur="callBusinessRuleBlur"
            :disabled="attr.disableField"
            style="text-align: right">
          </money>
        </div>

      </div>

    </el-form-item>

    <div v-if="moduleType === 'show'">
      <label>{{label}}</label>
      <p>
        {{ getPrefix() }} &nbsp; {{ formatValue(updateFieldValue) }}
      </p>
    </div>

    <span v-if="moduleType === 'list' && updateFieldValue">
      {{ getPrefix() }} &nbsp; {{ formatValue(updateFieldValue) }}
    </span>

  </div>
</template>
<style scoped>
.v-money {
  height: 36px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid rgb(217, 204, 191);
  text-align: right;
  padding-right: 12px;
}
.v-money:focus {
  outline: none;
  border-color: #FF6600 !important;
}
</style>



// WEBPACK FOOTER //
// SgsRenderFloat.vue?d3fa71e8